import { useaxios } from "../../../utils/useaxios";
export default (document_id) => {
    return useaxios('document/read.php', { document_id }).then((res) => {
        return res;
    });
}